import React, { Component } from 'react';

// import Circles from '../../components/Circles';
import Cards from '../../components/Cards';
import PathContext from "../../context/path";
// import ScrollTop from '../../components/ScrollTop';
import Footer from '../../components/Footer';
import FooterCover from '../../components/FooterCover';
import Socials from '../../components/Socials';
import ProgressTherapy from '../../components/ProgressTherapy';
import ProgressTherapyDesktop from '../../components/ProgressTherapyDesktop';
import ScrollDown from '../../components/ScrollDown';
import HeightSlider from '../../components/HeightSlider';
import styles from './Therapy.module.sass';
// import './img/main.bg.png';

class Therapy extends Component {
	state = {
		bodyOffset: false
	}
	static contextType = PathContext;
	path = this.context;
	refWrap = React.createRef();
	scrollSlider = null;
	componentDidMount() {
		window.scrollTo(0, 0);
		this.setHeight = this.setHeight.bind(this);
		this.setHeight();
		window.addEventListener('resize', this.setHeight);
		if (window.innerWidth > 767) {
			this.scrollSlider = <div className={styles.progress}>
				<HeightSlider height={3}>
					<ProgressTherapyDesktop />
				</HeightSlider>
			</div>
		}else{
			this.scrollSlider = <div className={styles.progress}>
			<ProgressTherapy />
		</div>;
		}
		this.setState({});
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.setHeight, false);
	}
	setHeight() {
		let vh = window.innerHeight * 0.01;
		this.refWrap.current.style.setProperty('--vh', `${vh}px`);
	}

	render() {
		// let scrollSlider = <div className={styles.progress}>
		// 	<ProgressTherapy />
		// </div>;

		// if (window.innerWidth > 767) {
		// 	scrollSlider = <div className={styles.progress}>
		// 		<HeightSlider height={3}>
		// 			<ProgressTherapyDesktop />
		// 		</HeightSlider>
		// 	</div>
		// }
		return <div ref={this.refWrap} className={styles.wrap}>

			{/* BG */}
			<div className={styles.bg1}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/therapy-bg-desktop.png`} />
					<img src={`${this.path}/img/therapy-bg.png`} alt="" />
				</picture>
			</div>
			<div className={styles.bg2}>
				<picture>
					<source media="(min-width: 768px)" srcSet={`${this.path}/img/therapy-bg2-desktop.png`} />
					<img src={`${this.path}/img/therapy-bg2.png`} alt="" />
				</picture>
			</div>
			<div className={styles.cover}>
				<div className="container">
					<h1 className={styles.title}>
					HIV – is always lethally dangerous?
					</h1>
					<div className={styles.text}  data-aos="fade-up">

					How therapy works and why it is needed
					</div>

					<div className={styles.img}>
						<img src={`${this.path}/img/gifs/icon3.gif`} alt="" />
					</div>
					<div className={styles.socials}>
						<Socials suffix={'blue'} />
					</div>
				</div>
				<ScrollDown />
			</div>
			<div className={styles.info}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2>HIV is not a death sentence — it’s an easily controlled chronic illness</h2>
					<div className={styles.text_2}>
						<p>The World Health Organization has categorized HIV as a chronic illness. Even if infected, you can live a long, fulfilling life by getting therapy regularly.</p>
						<p>It can be lethal if you allow your organism to fully weaken and the infection develops to the AIDS stage. Even in such cases you can get your health back if you start therapy as soon as possible.</p>
					</div>
					</div>
					<div className={styles.fact}  data-aos="fade-up">
						<div className={styles.fact_number}>72 years</div>
						<div className={styles.fact_text}>That’s the average lifespan of people with HIV if it’s identified in good time and treated. It’s also the average life expectancy of Russians who aren’t infected.</div>

					</div>
					<div  data-aos="fade-up">
					<h2>As with the majority of illnesses, there is a therapeutic treatment for HIV</h2>
					<div className={styles.text_3}>
						<p>For the time being, HIV can’t be entirely cured, but it can be managed with antiretroviral therapy (ART).</p>
						<p>This comprises a combination of medicines that block the virus and prevent it from further development.</p>
					</div>
					</div>
				</div>
			</div>
			<div>
			{this.scrollSlider}
			</div>
			<div className={styles.info_2}>
				<div className="container">
					<div  data-aos="fade-up">
					<h2>With therapy you can live a normal life</h2>
					<div className={styles.text_4}>
						<p>If a person regularly undergoes antiretroviral therapy and has an undetectable viral load (HIV isn’t identified by blood tests) then good health is guaranteed and the person can’t transmit HIV to his sexual partners. Yes — even if he or she has sex without a condom.</p>
						<p>When taking antiretroviral medicines you can conceive and give birth to a healthy baby — the risk of transmitting HIV to the baby is minimal.</p>
					</div>
					</div>
					<div className={styles.lead}  data-aos="fade-up">If everyone who is HIV positive starts getting therapy, no one else will fall ill</div>
					<div className={styles.illustration}>
						<img src={`${this.path}/img/gifs/pers_touch.gif`} alt="" />
					</div>
					<div  data-aos="fade-up">
					<h2>Knowing your HIV status is crucial for therapy in the early stages</h2>
					<div className={styles.text_5}>
						<p>Antiretroviral therapy achieves the best results if it’s begun as early as possible after infection. </p>
						<p>You can only find out if a person has HIV by taking a test.</p>
					</div>
					</div>
				</div>
			</div>
			<div className={styles.faq}>
				
			<div className="container">
				<div className={styles.footer_cover}>
						<FooterCover />
					</div>
				
				<div className={styles.cards}>
					<Cards />
				</div>
				</div>
			</div>
			{/* <ScrollTop color={'blue'} /> */}
			<div className={styles.footer}>
				<Footer />
			</div>
		</div>;
	}
}

export default Therapy;
